import { render, staticRenderFns } from "./EmergencyMessageAlert.vue?vue&type=template&id=da8845fe&scoped=true"
import script from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"
export * from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8845fe",
  null
  
)

export default component.exports